// Cableado entre el árbol real de rutas y el modelo puro de secciones.
// Aquí viven los imports de `routes.js`; `nav-sections.js` se mantiene libre de
// ellos para poder testearse en entorno node.
import { protectedRoute, protectedRoutesWithoutLayout } from './routes'
import { canAccess } from './access'
import {
  visibleSections, sectionForRoute, sectionLeaves, firstAccessibleRouteIn, SECTION_DEFS,
} from './nav-sections'

const tree = () => protectedRoute.concat(protectedRoutesWithoutLayout)

export const navSections = (user) => visibleSections(tree(), user)
export const activeSectionId = (routeName) => sectionForRoute(tree(), routeName)
export const sectionEntry = (sectionId, user) => firstAccessibleRouteIn(tree(), sectionId, user)

// Sustituye al acceso por índice de los dos drawers (`routes[0].children` y
// `routes[1].children`), que se rompía en silencio si alguien reordenaba el
// array de rutas.
//
// La raíz se deriva de `SECTION_DEFS` (rootName / rootPath) en vez de
// repetirla como literal: es la misma divergencia menú-vs-modelo que esta
// rama existe para eliminar. Un `sectionId` sin raíz declarada (o inexistente
// en `SECTION_DEFS`) devuelve `[]` en vez de caer en reports por descarte.
export function sectionMenu(sectionId, user) {
  const def = SECTION_DEFS.find((s) => s.id === sectionId)
  let root = null
  if (def && def.rootName) root = protectedRoute.find((r) => r.name === def.rootName)
  else if (def && def.rootPath) root = protectedRoute.find((r) => r.path === def.rootPath)
  if (!root) return []
  const keep = (item) => {
    if (!canAccess(item, user)) return null
    if (item.children && item.children.length) {
      const children = item.children.map(keep).filter(Boolean)
      return children.length ? { ...item, children } : null
    }
    return item
  }
  return (root.children || []).map(keep).filter(Boolean)
}

export { sectionLeaves }
